module.exports = __webpack_public_path__ + "img/direction-right.d84df0f2.svg";